import React, { useEffect, Suspense, lazy } from 'react';
import { trackPageView } from './utils/metaPixel';
import { TopBanner } from './components/TopBanner';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Expert } from './components/Expert';
import { Benefits } from './components/Benefits';
import { Included } from './components/Included';
// Below-the-fold → code-split (no bloquean LCP)
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const BonusShowcase = lazy(() => import('./components/BonusShowcase').then(m => ({
  default: m.BonusShowcase
})));
const Offer = lazy(() => import('./components/Offer').then(m => ({
  default: m.Offer
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const PurchaseToast = lazy(() => import('./components/PurchaseToast').then(m => ({
  default: m.PurchaseToast
})));
const SectionFallback = () => <div className="min-h-[200px]" aria-hidden="true" data-id="element-0" />;
export function App() {
  useEffect(() => {
    // Diferimos PageView para no competir con LCP
    const idle = (window as any).requestIdleCallback || ((cb: () => void) => setTimeout(cb, 300));
    idle(() => trackPageView());
  }, []);
  return <div className="min-h-screen bg-stone-50 font-sans" data-id="element-1">
      <TopBanner data-id="element-2" />
      <Hero data-id="element-3" />
      <Problem data-id="element-4" />
      <Solution data-id="element-5" />
      <Expert data-id="element-6" />
      <Benefits data-id="element-7" />
      <Included data-id="element-8" />
      <Suspense fallback={<SectionFallback data-id="element-10" />} data-id="element-9">
        <Testimonials data-id="element-11" />
      </Suspense>
      <Suspense fallback={<SectionFallback data-id="element-13" />} data-id="element-12">
        <BonusShowcase data-id="element-14" />
      </Suspense>
      <Suspense fallback={<SectionFallback data-id="element-16" />} data-id="element-15">
        <Offer data-id="element-17" />
      </Suspense>
      <Suspense fallback={<SectionFallback data-id="element-19" />} data-id="element-18">
        <Guarantee data-id="element-20" />
      </Suspense>
      <Suspense fallback={<SectionFallback data-id="element-22" />} data-id="element-21">
        <FAQ data-id="element-23" />
      </Suspense>
      <Suspense fallback={<SectionFallback data-id="element-25" />} data-id="element-24">
        <FinalCTA data-id="element-26" />
      </Suspense>
      <Suspense fallback={null} data-id="element-27">
        <PurchaseToast data-id="element-28" />
      </Suspense>
    </div>;
}